module.exports = __webpack_public_path__ + "media/images/bg/patterns/activities/1-4f4c23f35c6f71b82aa5327a276d70db.svg";